import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 15.5 26.69' {...props}>
    <g data-name='Layer 2'>
      <text
        transform='translate(0 20.4)'
        fontSize={24}
        fill='undefined'
        fontFamily='Barlow-ExtraBold,Barlow'
        fontWeight={700}
        data-name='general content'
      >
        X
      </text>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CrossIcon.js